import type { FaireProductEntity } from "../../entity_types/product";

export const p_4355geemw7: FaireProductEntity = {
  token: "p_4355geemw7",
  type: "product",
  name: 'Flower Look Wine Glass-8.5"H(13oz)',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/d95bbd7321cff0bbff4a1973108d1e62f9dda644e935cd644a85b4bb85f20b03.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67a5323762add6253fb9951c3bed4eb5ffb1ebdc22e9cc64a014fdda20166f33.jpeg",
    "https://cdn.faire.com/fastly/ee020698e0fcbe00af084dbe5f31588bc805479bf40e1a2b445a716d28e831d3.jpeg",
    "https://cdn.faire.com/fastly/d053c75d393e56f2c0e29d94aeca4a1c87611afde588aba40d766546ce8369ad.jpeg",
    "https://cdn.faire.com/fastly/d06926784ef8e02b4627369bd73004256ec3e3a681e4263c62129d28bd61bf33.jpeg",
    "https://cdn.faire.com/fastly/37c07df3a4052510aa16111d10e38ae9d778075dec78f4a97c595868b13ed675.jpeg",
  ],
  priceDollars: 10,
  description:
    "Our Flower Look Wine Glass adds a delightful, feminine touch to your celebrations. Crafted in delicate pink, with a green base will impress your guests and elevate the ambience of any occasion. Also available in a flute or coupe glass.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:10.226Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
